import { render, staticRenderFns } from "./HistoryMasseuse.vue?vue&type=template&id=686dc294&scoped=true&"
import script from "./HistoryMasseuse.vue?vue&type=script&lang=js&"
export * from "./HistoryMasseuse.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMasseuse.vue?vue&type=style&index=0&id=686dc294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686dc294",
  null
  
)

export default component.exports